import { css } from 'styled-components';

export const withFancyScrollbar = css`
	&::-webkit-scrollbar {
		display: block;
		width: 4px;
	}

	&::-webkit-scrollbar-track {
		background: rgba(0, 0, 0, 0.05);
	}

	&::-webkit-scrollbar-thumb {
		background: #bbb;
		border-radius: 100px;
	}
`;

export const withFancyHorizontalScrollbar = css`
	&::-webkit-scrollbar {
		display: block;
		height: 4px;
	}

	&::-webkit-scrollbar-track {
		background: rgba(0, 0, 0, 0.05);
	}

	&::-webkit-scrollbar-thumb {
		background: #bbb;
		border-radius: 100px;
	}
`;

export const backgroundColorOptions = css`
	${({ theme }) => css`
		${props =>
			Object.keys(theme.colors).map(key => {
				if (props.backgroundColor === key) {
					return `background-color: ${theme.colors[key]}`;
				}

				return null;
			})}
	`};
`;
